import React from 'react';
import { customURLs, getToken, notAllowedButtons, showContactCredentialCardBorder, NullBadgeUrl, utcToLocalDateTime, StatusReason } from "../../tools/utils";
import { Loader } from '../../components/Loader';
import { useMyCredential } from '../../hooks/useMyCredential';
import { Link, useLocation } from 'react-router-dom';
import useIsMobile from '../../hooks/Helper/useIsMobile';
import { AccessControl, useGlobalContext } from '../../hooks/Helper/GlobalContext';
import { NotificationBanner } from '../../components/NotificationBanner/NotificationBanner';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import i18n from '../../Localization/I18next';
import { usePrerequisiteCredential } from '../../hooks/usePrerequisiteCredential';
import { usePrerequisiteTree } from '../../hooks/usePrerequisiteTree';
import { useCredential } from '../../hooks/useCredential';
import { AvailableCredential } from '../../types/allcredential';
import { PreReqCredentialCard } from '../../components/Cards/PreRequisiteCard';

export const MyCredential = ({ headerMarginTop }: { headerMarginTop: number }) => {
    const { ProviderAccessControl, photoBannerVisible, PhotoBannerMessage } = useGlobalContext();
    const { t } = useTranslation();
    // const { id } = useLocation().state;
    const contactcredentialId = window.location.pathname.split('/')[2];
    const { REACT_APP_BASE_URL, REACT_APP_LMS_BASE_URL } = process.env;
    const myCredentialQuery = useMyCredential(contactcredentialId);
    const myCredentialData = myCredentialQuery.data?.data?.Data;

    const token = getToken()
    const credentialButtons = myCredentialData?.EarnedCredential?.CredentialButtons.find(x => x.CredentialsName === myCredentialData?.EarnedCredential.myCCOLabel)
        ?.MyCredentials || [];
    const handleClick = (event) => {
        const form = document.getElementById('myForm') as HTMLFormElement;
        form.submit();
    }
    const isMobile = useIsMobile();
    const credentialStatusReason = myCredentialData?.EarnedCredential.StatusReason;
    const isRenewal = showContactCredentialCardBorder(myCredentialData ? myCredentialData?.EarnedCredential.ExpiryDate : '', () => { });
    const language = i18n.language;
    const state = encodeURIComponent('https://trueb2c.live/wp-admin/');

    const isDateWithinLast12Months = (dateString) => {
        const currentDate = new Date();
        const oneYearAgo = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

        const startDate = new Date(oneYearAgo.getFullYear(), oneYearAgo.getMonth(), oneYearAgo.getDate(), 0, 0, 0); // Start of the range
        const endDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59); // End of the range

        const testDate = new Date(dateString.split('T')[0]);

        return testDate >= startDate && testDate <= endDate;
    };

    const credentialId = myCredentialData?.EarnedCredential?.Id;
    const credentials = useCredential(credentialId, language);
    const userCredentials = credentials.data?.data?.Data || {} as AvailableCredential;
    const credentialObj = userCredentials;

    const preRequisiteQuery = usePrerequisiteCredential(credentialId, language);
    const preRequisiteData = preRequisiteQuery.data?.data?.Data;

    const preRequisiteTreeQuery = usePrerequisiteTree(credentialId, language);
    const preRequisiteTreeData = preRequisiteTreeQuery.data?.data?.Data;
    const preRequisiteTreeDataReversed = preRequisiteTreeData?.reverse();

    const recentExams = credentialObj?.ExamDetails?.filter((examDetail) =>
        isDateWithinLast12Months(examDetail.TestDate)
    );

    const isPreReqExpiryMoreThan60Days = (expireDate?: string) => {
        if (!expireDate || expireDate === '0001-01-01T00:00:00') return false;

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const expiry = new Date(expireDate);
        expiry.setHours(0, 0, 0, 0);
        const diffInDays = (expiry.getTime() - today.getTime()) / (1000 * 60 * 60 * 24);
        return diffInDays > 60;
    };

    const isPreReqValid = !preRequisiteData || (preRequisiteData?.Status === StatusReason.Approved && isPreReqExpiryMoreThan60Days(preRequisiteData?.ExpireDate));

    //     const handleClick=(event)=>{
    //      event.preventDefault();
    //  //    const form= document.getElementById('myForm') as HTMLFormElement;
    //  //    form.submit();
    //          const token = getToken();  // Function to get the token
    //          const redirect = encodeURIComponent('https://trueb2c.live/testing-personnel');
    //          const targetUrl = `https://trueb2c.live/?code=${token}&state=${state}`;

    //          window.open(targetUrl, '_blank'); 
    //      }
    return (

        <div id="main-content" style={{ marginTop: headerMarginTop }}>
            <div className="cco_content_area cco_content_area_0">
                <article className="react-container">
                  <NotificationBanner
                    background="red"
                    showBanner={photoBannerVisible}
                    message={PhotoBannerMessage}
                    color="white"
                  />
                    <div className="cco_section cco_section_0">
                        <div className="cco_row cco_row_8">
                            <div className="cco_col">
                                <div className="cco_text cco_text_11">
                                    <div className="cco_text_inner">
                                        <strong>
                                            <a href="/testing-personnel">{t("myCredential.breadcrumbsLink")}</a>
                                        </strong>{' '}
                                        {'>'} {myCredentialData?.EarnedCredential?.Name || ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="cco_row">
                            <div className="cco_col">
                                {myCredentialQuery.isLoading ? (<Loader />) : myCredentialQuery.error ? (<p>{myCredentialQuery.error.message}</p>) : (
                                    <div className="cco_card cco_card_2" style={{ paddingLeft: "20px" }}>
                                        <div className="cco_card_body">
                                            <div className="cco_card_aside">
                                                <div className="cco_img">
                                                    <span className="cco_img_wrap">
                                                        {/* <img style={{border:myCredentialData?.EarnedCredential.StatusReason==='Approved'?'':"1px solid rgb(0 0 0 / 5%)",borderRadius:myCredentialData?.EarnedCredential.StatusReason==='Approved'?'':"23px"}} alt={myCredentialData?.EarnedCredential?.Name} src={myCredentialData?.EarnedCredential.StatusReason==='Approved'?myCredentialData?.EarnedCredential?.BadgeUrl:NullBadgeUrl} /> */}
                                                        <img style={{ border: (myCredentialData?.EarnedCredential.StatusReason === 'Approved' || myCredentialData?.EarnedCredential.StatusReason === 'PendingRenewal') && myCredentialData?.EarnedCredential.BadgeUrl != null ? '' : "1px solid rgb(0 0 0 / 5%)", borderRadius: (myCredentialData?.EarnedCredential.StatusReason === 'Approved' || myCredentialData?.EarnedCredential.StatusReason === 'PendingRenewal') && myCredentialData?.EarnedCredential.BadgeUrl != null ? '' : "23px" }} alt={myCredentialData?.EarnedCredential.Name} src={(myCredentialData?.EarnedCredential.StatusReason === 'Approved' || myCredentialData?.EarnedCredential.StatusReason === 'PendingRenewal') && myCredentialData?.EarnedCredential.BadgeUrl != null ? myCredentialData?.EarnedCredential.BadgeUrl : NullBadgeUrl} />
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="cco_card_main" style={{ padding: '10px' }}>
                                                <div className={'cco_text cco_text_9'}>
                                                    <div className={'cco_text_inner'}>
                                                        <h3><strong>{myCredentialData?.EarnedCredential?.myCCOLabel || ''}</strong></h3>
                                                        <div>{t("myCredential.status")}: {myCredentialData?.EarnedCredential.StatusReason ? t(`myCredential.Statuses.${myCredentialData?.EarnedCredential.StatusReason}`, myCredentialData?.EarnedCredential.StatusReason) : ''}</div>
                                                        {myCredentialData?.EarnedCredential?.ExpiryDate && (
                                                            <div>
                                                                {t("myCredential.expiryLabel")}:{' '}
                                                                {myCredentialData?.EarnedCredential.ExpiryDate.split('T')[0] ===
                                                                    '0001-01-01'
                                                                    ? t("myCredential.noExpiry")
                                                                    : myCredentialData?.EarnedCredential.ExpiryDate.split('T')[0]}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            {credentialStatusReason === 'PendingAudit' &&

                                                <div className="cco_card_main" style={{ padding: '10px' }}>
                                                    <div className="cco_text cco_text_16" >
                                                        <div className={'cco_text_inner'}>
                                                            {t("myCredential.pendingAuditMessage")}
                                                        </div></div></div>
                                            }
                                            {credentialStatusReason === 'PendingCertification' &&
                                                <div className="cco_card_main" style={{ padding: '10px' }}>
                                                    <div className="cco_text cco_text_16" >
                                                        <div className={'cco_text_inner'}> {t("myCredential.pendingCertification")}
                                                        </div>  </div></div>
                                            }
                                            {isRenewal && credentialStatusReason === 'Approved' && !preRequisiteQuery.isLoading &&
                                                <div className="cco_row cco_row_1" style={{ width: isMobile ? '100%' : 'auto' }}>
                                                    <div className="cco_col " style={{
                                                        display: 'flex',
                                                        flexDirection: isMobile ? 'column' : 'row',
                                                        alignItems: isMobile ? 'flex-start' : 'center',
                                                        justifyContent: 'flex-start',
                                                        gap: isMobile ? '10px' : '0'
                                                    }}>
                                                        {preRequisiteData && !isPreReqValid && (
                                                            <div className="cco_card_main" style={{ padding: isMobile ? '10px 0' : '10px', width: isMobile ? '100%' : 'auto' }}>
                                                                <div className="cco_text cco_text_16">
                                                                    <div className={'cco_text_inner'}>
                                                                        <strong>Must complete pre-requisite renewal before you can proceed. Click on pre-requisite below.</strong>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        <ul className="cco_menu cco_menu_3" style={{ margin: isMobile ? '10px 0' : '0' }}>
                                                            <li
                                                                className="cco_menu_item cco_menu_item_primary"
                                                                style={{
                                                                    marginBottom: '0px',
                                                                }}
                                                            >
                                                                <Link
                                                                    to={isPreReqValid ? `/credential-renewal/${contactcredentialId}` : '#'}
                                                                    state={isPreReqValid ? { eot: contactcredentialId } : undefined}
                                                                    style={{
                                                                        height: "auto",
                                                                        border: "2px solid black",
                                                                        backgroundColor: isPreReqValid ? "red" : "gray",
                                                                        color: "white",
                                                                        padding: isMobile ? "10px 15px" : "12px 21px",
                                                                        fontSize: isMobile ? "18px" : "22px",
                                                                        fontWeight: "600",
                                                                        cursor: isPreReqValid ? "pointer" : "not-allowed",
                                                                        pointerEvents: isPreReqValid ? "auto" : "none",
                                                                        textDecoration: 'none',
                                                                        display: 'inline-block',
                                                                        textAlign: 'center'
                                                                    }}
                                                                >
                                                                    {t("myCredential.renewButton")}
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* WorkShop Lists */}
                        {myCredentialData?.EarnedCredential.WorkShops == true && (
                            <><div className="cco_row cco_row_2">
                                <div className="cco_col">
                                    <div className="cco_text cco_text_2">
                                        <div className="cco_text_inner">
                                            <h2>  {t("myCredential.workshopTitle")} </h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                                <div className="cco_row cco_row_3">
                                    <div className="cco_col">
                                        {myCredentialQuery.isLoading ? (<Loader />) : myCredentialQuery.error ? (<p>{myCredentialQuery.error.message}</p>) : (
                                            myCredentialData?.EarnedCredential.workshopApplications.length > 0 ? (
                                                <ul className="cco_accordion">
                                                    {myCredentialData?.EarnedCredential.workshopApplications.map((WorkShop, index: number) => {
                                                        return (
                                                            <li className="cco_accordion_item active" key={index}>
                                                                <div className="cco_accordion_item_body">
                                                                    <table className="cco_table">
                                                                        <tbody className="cco_table_body">
                                                                            <tr className="cco_table_row">
                                                                                <td className="cco_table_cell cco_table_cell_large">
                                                                                    <div className="cco_blurb cco_blurb_0">
                                                                                        <div className="cco_blurb_label">{t("myCredential.startEnd")}</div>
                                                                                        <div className="cco_blurb_value">
                                                                                            {/* <strong title='EST DateTime'>{moment(WorkShop.StartDateTime).tz('America/New_York').format("MM-DD-YYYY hh:mmA") || '-'}</strong> */}
                                                                                            <strong>   {(WorkShop.Format === 'Virtual') ? utcToLocalDateTime(WorkShop.StartDateTime || '-') : (moment(WorkShop.StartDateTime).format('MM-DD-YYYY hh:mmA') + " (" + (WorkShop.StartdateTimeZone || '-') + ")")}</strong>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="cco_blurb cco_blurb_0">
                                                                                        <div className="cco_blurb_label">{t("myCredential.name")}</div>
                                                                                        <div className="cco_blurb_value">
                                                                                            <strong>{WorkShop.WorkShopName || '-'}</strong>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="cco_blurb cco_blurb_align_right cco_blurb_0">
                                                                                        <div className="cco_blurb_label">{t("myCredential.launchLink")}</div>
                                                                                        <div className="cco_blurb_value">
                                                                                            {/* <strong>{WorkShop.LaunchLink || '-'}</strong> */}
                                                                                            <a target={WorkShop.LaunchLink ? '_blank' : ''} href={WorkShop.LaunchLink ? WorkShop.LaunchLink.toUpperCase().startsWith('W') ? 'https://' + WorkShop.LaunchLink : WorkShop.LaunchLink : 'javascript:void(0)'}>{WorkShop.LaunchLink || '-'}</a>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                <td className="cco_table_cell">
                                                                                    <div className="cco_blurb cco_blurb_align_right cco_blurb_0">
                                                                                        <div className="cco_blurb_label">{t("myCredential.status")}</div>
                                                                                        <div className="cco_blurb_value">
                                                                                            <strong>{t(`myCredential.workshopStatuses.${WorkShop.Status}`, WorkShop.Status) || '-'}</strong>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="cco_blurb cco_blurb_0">
                                                                                        <div className="cco_blurb_label">{t("myCredential.location")}</div>
                                                                                        <div className="cco_blurb_value">
                                                                                            <strong>{WorkShop.LocationName || '-'}</strong>
                                                                                        </div>
                                                                                    </div>


                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </li>
                                                        )


                                                    })}
                                                </ul>
                                            ) : (
                                                <p>{t("myCredential.noWorkshop")}</p>
                                            )
                                        )}
                                    </div>
                                </div></>
                        )}

                        {/* === Journey Status Section === */}
                        <>
                            <div className="cco_row cco_row_7">
                                <div className="cco_col cco_col_6">
                                    <div className="cco_text cco_text_10">
                                        <div className="cco_text_inner">
                                            <h2>
                                                <strong>{(credentialObj.myCCOLabel && credentialObj.myCCOLabel + " Journey Status") ||
                                                    ""}</strong>
                                            </h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="cco_row cco_row_3">
                                <div className="cco_col">
                                    {preRequisiteTreeQuery.isLoading ? (
                                        <Loader />
                                    ) : preRequisiteTreeQuery.error ? (
                                        <p>{preRequisiteTreeQuery.error.message}</p>
                                    ) : preRequisiteTreeDataReversed &&
                                        preRequisiteTreeDataReversed.length > 0 ? (
                                        <div
                                            className="cco_group cco_group_2"
                                            style={{
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            {credentialObj?.Exams === true && (credentialObj?.PreReqCredentialName === 'Proctor-Practical' || credentialObj?.PreReqCredentialName === 'MBL Workshop' || credentialObj?.PreReqCredentialName === 'THO Workshop') &&
                                                <>
                                                    <div className="cco_group_item" style={{ marginTop: '10px' }}>
                                                        <a href={(recentExams.length === 0 && credentialObj.CertificationDetails.length === 0) ? "/dashboard/" : ''} style={{ textDecoration: 'none', color: (recentExams.length === 0 && credentialObj.CertificationDetails.length === 0) ? 'red' : '#666' }}>
                                                            <div className={`cco_card cco_card_myCredential ${recentExams.length === 0
                                                                ? (credentialObj.CertificationDetails && credentialObj.CertificationDetails.length > 0
                                                                    ? 'purchased-card'
                                                                    : 'notcompleted-card')
                                                                : 'purchased-card'
                                                                }`}>
                                                                <div className="cco_card_body">
                                                                    <div className="cco_card_main" style={{ width: "100%", padding: "10px" }}>
                                                                        <div className="cco_text cco_text_myCredential">
                                                                            <div className="cco_text_inner">
                                                                                {
                                                                                    credentialObj.CertificationDetails && credentialObj.CertificationDetails.length > 0 ? (
                                                                                        credentialObj.CertificationDetails.map((certDetail, index) => (
                                                                                            <div key={index}>
                                                                                                <h3>{certDetail.CertificationTypeName}</h3>
                                                                                                <div>Expiration Date: {certDetail.CertificationExpirationDate.split('T')[0] === '0001-01-01' ? 'Not Available' : certDetail.CertificationExpirationDate.split('T')[0]}</div>
                                                                                            </div>
                                                                                        ))
                                                                                    ) : recentExams && recentExams.length > 0 ? (
                                                                                        credentialObj.ExamDetails
                                                                                            .filter((examDetail) => isDateWithinLast12Months(examDetail.TestDate))
                                                                                            .map((examDetail, index) => (
                                                                                                <div key={index}>
                                                                                                    <h3><strong>{examDetail.CredentialNameType}</strong></h3>
                                                                                                    <div>Status: {examDetail.OverallStatus}</div>
                                                                                                    <div>Test Date: {examDetail.TestDate.split('T')[0] === '0001-01-01' ? 'Not Available' : examDetail.TestDate.split('T')[0]}</div>
                                                                                                </div>
                                                                                            ))
                                                                                    ) : (
                                                                                        <>
                                                                                            <h3><strong>Written Exam Required </strong></h3>
                                                                                            <div>Click here to sign up</div>
                                                                                        </>
                                                                                    )
                                                                                }

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                    <div className="desktop-arrow"></div>
                                                    <div className="mobile-arrow"></div>
                                                </>
                                            }

                                            {credentialObj?.Certifications === true && (credentialObj?.PreReqCredentialName === 'Proctor-Practical' || credentialObj?.PreReqCredentialName === 'MBL Workshop' || credentialObj?.PreReqCredentialName === 'THO Workshop') &&
                                                <>
                                                    <div className="cco_group_item" style={{ marginTop: '10px' }}>
                                                        <a href={(credentialObj.ExamDetails.length === 0) ? "/dashboard/" : ''} style={{ textDecoration: 'none', color: (credentialObj.CertificationDetails.length === 0) ? 'red' : '#666' }}>
                                                            <div className={`cco_card cco_card_myCredential ${credentialObj.CertificationDetails.length === 0 ? 'notcompleted-card' : 'purchased-card'}`}>
                                                                <div className="cco_card_body">
                                                                    <div className="cco_card_main" style={{ width: "100%", padding: "10px" }}>
                                                                        <div className="cco_text cco_text_myCredential">
                                                                            <div className="cco_text_inner">
                                                                                {credentialObj.CertificationDetails.length === 0 ? (
                                                                                    <>
                                                                                        <h3><strong>Certification Required </strong></h3>
                                                                                        <div>Click here to sign up</div>
                                                                                    </>
                                                                                ) : (
                                                                                    credentialObj.CertificationDetails.map((certDetail, index) => (
                                                                                        <div key={index}>
                                                                                            <h3><strong>{certDetail.CertificationTypeName}</strong></h3>
                                                                                            <div>Expiration Date: {certDetail.CertificationExpirationDate.split('T')[0] === '0001-01-01' ? 'Not Available' : certDetail.CertificationExpirationDate.split('T')[0]}</div>
                                                                                        </div>
                                                                                    ))
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                    <div className="desktop-arrow"></div>
                                                    <div className="mobile-arrow"></div>
                                                </>
                                            }
                                            {preRequisiteTreeDataReversed.map(
                                                (credential, index) => (
                                                    <>
                                                        <PreReqCredentialCard
                                                            credential={credential}
                                                            index={index}
                                                            key={credential.PreReqCredentialId + index}
                                                        />
                                                    </>
                                                )
                                            )}

                                            <div
                                                className="cco_group_item"
                                                style={{ marginTop: "10px" }}
                                            >
                                                <a href={"javascript:void(0)"} style={{ color: "#666" }}>

                                                    <div className={`cco_card cco_card_myCredential ${myCredentialData.EarnedCredential.StatusReason === "Approved" ? 'purchased-card' : (myCredentialData.EarnedCredential.StatusReason === "Pending" || myCredentialData.EarnedCredential.StatusReason === "PendingRenewal") ? 'pending-card' : 'notcompleted-card'}`}
                                                    >
                                                        <div className="cco_card_body">
                                                            <div
                                                                className="cco_card_main"
                                                                style={{ width: "100%", padding: "10px" }}
                                                            >
                                                                <div className="cco_text cco_text_myCredential">
                                                                    <div className="cco_text_inner">
                                                                        <h3>
                                                                            <strong>{credentialObj.myCCOLabel}{" "}</strong>
                                                                        </h3>
                                                                        <div>Status: {myCredentialData.EarnedCredential.StatusReason}</div>
                                                                        <div>Expiration Date: {myCredentialData.EarnedCredential.ExpiryDate.split('T')[0] === '0001-01-01' ? 'Not Available' : myCredentialData.EarnedCredential.ExpiryDate.split('T')[0]}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    ) : (
                                        <p>
                                            {" "}
                                            There are no pre-requisites for{" "}
                                            {credentialObj && credentialObj.CredentialName}{" "}
                                            credential.
                                        </p>
                                    )}
                                </div>
                            </div>
                        </>
                        {/* === End Journey Status Section === */}


                        <div className="cco_row cco_row_2">
                            <div className="cco_col">
                                <div className="cco_text cco_text_2">
                                    <div className="cco_text_inner">
                                        <h2><strong>{myCredentialData?.EarnedCredential?.Name || ''} {t("myCredential.description")}</strong></h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="cco_row">
                            <div className="cco_col">
                                {myCredentialQuery.isLoading ? (<Loader />) : myCredentialQuery.error ? (<p>{myCredentialQuery.error.message}</p>) : (
                                    <div className="cco_card cco_card_2">

                                        <div className="cco_card_body">
                                        </div>
                                        {/* Credential Description */}

                                        {myCredentialData?.EarnedCredential.ProductDetails && (
                                            <div className="cco_card_footer">
                                                <div className="cco_text">
                                                    <div className="cco_text_inner" dangerouslySetInnerHTML={{ __html: myCredentialData?.EarnedCredential?.ProductDetails || '' }}></div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                        </div>


                        {ProviderAccessControl === AccessControl.Locked || ProviderAccessControl === AccessControl.Suspended ? (null) : (

                            <div className="cco_row cco_row_1" style={{ marginBottom: '12px' }}>
                                <div className="cco_col">
                                    <ul className="cco_menu cco_menu_0">
                                        {credentialButtons?.map((button: any, index: number) => {
                                            // if (index > 0 && button?.button_text) {
                                            if (
                                                (myCredentialData?.EarnedCredential.StatusReason === 'Pending' || 'PendingRenewal') &&
                                                button?.button_text === 'Open Online Learning Center'
                                            ) {
                                                return (
                                                    <li className="cco_menu_item cco_menu_item_primary" key={index}>
                                                        {/* <a style={{ maxWidth: "400px" }} href={button?.button_url || '#'}>{button?.button_text}</a> */}
                                                        <form
                                                            action={`${REACT_APP_LMS_BASE_URL}/dashboard`}
                                                            id='myForm' method="post">
                                                            <input type="hidden" name="state"
                                                                value={`${REACT_APP_LMS_BASE_URL}/wp-admin/`}
                                                            />
                                                            <input type="hidden" name="id_token" value={token} />
                                                            <a style={{ maxWidth: "400px" }}
                                                                onClick={handleClick}
                                                                href='#' >{button?.button_text}</a>

                                                        </form>

                                                    </li>
                                                );
                                            }
                                            if (myCredentialData?.EarnedCredential.StatusReason === 'Approved' || myCredentialData?.EarnedCredential.StatusReason === 'PendingRenewal') {
                                                return (
                                                    <li className="cco_menu_item cco_menu_item_primary" key={index}>
                                                        <a style={{ maxWidth: credentialButtons.length === 1 ? "400px" : '' }}
                                                            href={button?.button_url || '#'}
                                                        >{button?.button_text}</a>
                                                    </li>

                                                );
                                            }
                                            else {
                                                return null;
                                            }
                                        })}

                                        {(myCredentialData?.EarnedCredential.StatusReason === 'Approved' || myCredentialData?.EarnedCredential.StatusReason === 'PendingRenewal') && !notAllowedButtons.includes(myCredentialData.EarnedCredential.Name) && (
                                            <><li className="cco_menu_item cco_menu_item_primary">
                                                <a
                                                    href={`${token && customURLs?.manageMyTestAdministrationsUrl?.button_url
                                                        ? customURLs.manageMyTestAdministrationsUrl.button_url + '?id_token=' + token
                                                        : '#'}`}
                                                    target="_blank"
                                                    rel="noreferrer">
                                                    {t("myCredential.manageMyTestAdministrations") || "button_text"}
                                                    {/* t("myCredential.manageMyTestAdministrations") */}
                                                </a>
                                            </li>
                                                {/* {myCredentialData.EarnedCredential.ResourcesURL &&  myCredentialData.EarnedCredential.Name !== "Proctor-Practical" &&
                                <li className="cco_menu_item cco_menu_item_primary" >
                                        <a
                                        //  href={myCredentialData.EarnedCredential.ResourcesURL}
                                        >{myCredentialData.EarnedCredential.myCCOLabel} Resources</a>
                                </li>
                                } */}
                                                {myCredentialData.EarnedCredential.CredentialLocalizationDetails &&
                                                    <li className="cco_menu_item cco_menu_item_primary" >
                                                        <Link to={`/resource/${contactcredentialId}`}> {myCredentialData.EarnedCredential.myCCOLabel} {t("myCredential.Resources")}</Link>

                                                    </li>
                                                }
                                                {/* {(myCredentialData?.EarnedCredential.StatusReason === 'Approved'|| myCredentialData?.EarnedCredential.StatusReason==='PendingRenewal') &&  myCredentialData.EarnedCredential.Name === "Proctor-Practical" &&
                                <li className="cco_menu_item cco_menu_item_primary" >
                                    <Link to='/generatepdf'>{myCredentialData.EarnedCredential.myCCOLabel} Generate PDF</Link>
                                </li>
                                } */}


                                            </>
                                        )}

                                    </ul>
                                </div>
                            </div>
                        )}
                        {(myCredentialData?.EarnedCredential.StatusReason === 'Approved' || myCredentialData?.EarnedCredential.StatusReason === 'PendingRenewal') && myCredentialData.EarnedCredential.Name === 'TSC-EOT' && (
                            <div className="cco_row cco_row_1">
                                <div className="cco_col">
                                    <ul className="cco_menu cco_menu_0">
                                        <li className="cco_menu_item cco_menu_item_primary">
                                            <a style={{ maxWidth: !isMobile ? '300px' : '' }}
                                                href={`${token &&
                                                    customURLs?.paperPencilTestingUrl?.button_url
                                                    ? customURLs.paperPencilTestingUrl.button_url + '?id_token=' + token
                                                    : '#'
                                                    }`}
                                                target="_blank">
                                                {t("myCredential.paperPencilTesting") || 'Button Text'}
                                            </a>
                                            <div style={{ textAlign: "center" }}>
                                                <span>

                                                </span>
                                            </div>
                                        </li>
                                    </ul></div></div>

                        )}
                    </div>
                </article>
            </div>
        </div>
    );
};
